"use client";

import { useTranslation as useI18nextTranslation } from "react-i18next";
import { isRtlLanguage } from "i18n/config";

/**
 * Whether the active language is right-to-left. Use it only where RTL needs a
 * different value rather than different styling — picking a mirrored image
 * asset, say; anything CSS can express belongs in an `rtl:` variant instead.
 *
 * react-i18next's useTranslation re-renders the host component on language
 * change, so reading the language at render time stays in sync.
 */
export const useIsRtl = (): boolean => {
    const { i18n } = useI18nextTranslation();
    return isRtlLanguage(i18n.language);
};

/**
 * `dir` of the interface, for chrome (buttons, labels) that sits inside a
 * content block carrying its own direction — a lesson served in another
 * language, or a task that only exists in English — and must follow the UI.
 */
export const useUiDir = (): "ltr" | "rtl" => (useIsRtl() ? "rtl" : "ltr");
